import cn from "classnames"

import { Badge, Flex, Link, Tag, Text } from "@/atoms"
import {
  EXTERNAL_ROUTES,
  NAMES_ROUTES,
  VALUES_PARAMS
} from "@/const/routes.constants"
import { useTranslation } from "@/hooks/useTranslation"
import { ReadOutlined } from "@/icons"
import { Heading } from "@/molecules/Heading"
import { LinkButton } from "@/molecules/LinkButton"

import styles from "./NoIncidents.module.scss"

export const NoIncidents = (props: {
  type?: "dismissed" | "inactive" | "disabled" | "default" | "learning"
  extra?: React.ReactNode
}) => {
  const { type = "default" } = props
  const { ROOT: GOVERNANCE, WORKFLOWS } = NAMES_ROUTES.GOVERNANCE
  const to = `/${GOVERNANCE}/${WORKFLOWS}/${VALUES_PARAMS.NEW_ENTITY}`
  const overviewLink = `${EXTERNAL_ROUTES.API_DOCS}/triage/incidents-adr-overview`
  const instructionsLink = `${overviewLink}/enabling-incidents-adr`
  const { t } = useTranslation()
  const { t: tManagement } = useTranslation("translation", {
    keyPrefix: "triage.adr.management.empty"
  })

  const isInactive = type === "inactive"
  const isLearning = type === "learning"

  const gap = isInactive || isLearning ? 16 : 8

  return (
    <div
      className={cn(styles.container, {
        [styles.containerInactive]: isInactive,
        [styles.containerLearning]: isLearning
      })}
    >
      {isLearning && (
        <Tag className={styles.tagLearning}>
          <Badge status="processing" text={tManagement(`${type}.badge`)} />
        </Tag>
      )}
      {!isLearning && (
        <Heading level={4} title={tManagement(`${type}.title`)} />
      )}
      <Flex vertical align="center" gap={gap}>
        <Flex vertical align="center">
          <Text type="secondary">{tManagement(`${type}.line1`)}</Text>
          <Text type="secondary">{tManagement(`${type}.line2`, "")}</Text>
        </Flex>
        {type === "default" && (
          <Link
            to={to}
            state={{
              prePopulateData: {
                trigger: {
                  category: "Event_Driven",
                  type: "Incident"
                },
                currentScope: "all"
              }
            }}
          >
            {t("settings.automatedActions.table.actions.create")}
          </Link>
        )}
        {isInactive && (
          <LinkButton
            type="primary"
            icon={<ReadOutlined />}
            target="_blank"
            href={instructionsLink}
          >
            {tManagement("inactive.link")}
          </LinkButton>
        )}
        {isLearning && (
          <LinkButton
            type="link"
            icon={<ReadOutlined />}
            target="_blank"
            href={overviewLink}
          >
            {tManagement("learning.link")}
          </LinkButton>
        )}
      </Flex>
      {props.extra}
    </div>
  )
}
